/* Keep the capacity band tied to the real selected variant. Purchase, media,
   price and availability remain owned by the existing product components. */
(function () {
  'use strict';
  document.addEventListener('sousleau:variant:changed', function (event) {
    const scope = event.target.closest('[data-thrive-result]');
    if (!scope || !event.detail) return;
    const variant = event.detail;
    const label = scope.querySelector('[data-result-format]');
    if (label) label.textContent = variant.title;
    const doses = scope.querySelector('[data-result-doses]');
    if (doses) {
      const match = /^(\d+)\s*ml\b/i.exec(variant.title);
      doses.hidden = !match;
      if (match) doses.textContent = doses.dataset.doseTemplate.replace('__count__', match[1]);
    }
  });
})();
